<template>
  <section class="leaderboard">
    <img alt="Safety In Focus" src="@/assets/SIP_logo_XL.png">
    <TopPlayers :records="playerScores" />
    <TopRegional :records="regionalScores" />
  </section>
</template>

<script>
import TopPlayers from '@/components/TopPlayers'
import TopRegional from '@/components/TopRegional'

import RecordService from '@/services/RecordService'

export default {
  name: 'leaderboard',
  components: {
    TopPlayers,
    TopRegional
  },
  data() {
    return {
      playerScores: [{}, {}, {}, {}, {}],
      regionalScores: [],
      polling: null,
      regions: ["CENTRAL", "GULF", "MID-ATLANTIC", "MIDSOUTH", "MIDWEST",
                "NEW ENGLAND", "NJ METRO", "NORTHERN PLAINS", "NY METRO", "OHIO VALLEY",
                "PACIFIC MOUNTAIN DESERT", "PACIFIC CENTRAL", "PACIFIC NORTH",
                "PACIFIC NORTHWEST", "PAC SOUTH", "SOUTH ATLANTIC", "SOUTH FLORIDA/PR",
                "SOUTHEAST", "SOUTHWEST"]
    }
  },
  methods: {
    pollData () {
      this.getScores()
      this.getRegionScores()
      this.polling = setInterval(() => {
        this.getScores()
        this.getRegionScores()
      }, 30000)
    },
    getScores() {
      RecordService.getPlayerScores().then((resp) => {
        let data = resp.data

        if(data.length > 0) {
          this.playerScores = data.sort(function(a, b) {
            return a.score - b.score;
          });
          this.playerScores = this.playerScores.reverse().slice(0, 5)
        } else {
          this.playerScores = [{}, {}, {}, {}, {}]
        }
      })
    },
    getRegionScores() {
      let regions = this.regions
      let regionalScores = []

      RecordService.getPlayerScores().then(function(resp) {
        let data = resp.data

        regions.forEach(function(region) {
          let regionalPlayers = data.filter(function(player) {
            return player["REGION"].includes(region)
          }).sort(function(a, b) {
            return a.score - b.score;
          }).reverse();

          // eslint-disable-next-line no-console
          console.log(regionalPlayers)

          let player = typeof regionalPlayers[0] !== 'undefined' ? regionalPlayers[0].SM_NAME : "XXXX"
          let score = typeof regionalPlayers[0] !== 'undefined' ? regionalPlayers[0].score : 0

          regionalScores.push({player: player, region: region, score: score})
        })
      })

      this.regionalScores = regionalScores
    }
  },
  beforeDestroy () {
    clearInterval(this.polling)
    document.body.classList.remove("leaderboard")
  },
  mounted() {
    this.$ga.page('/leaderboard')
    this.pollData()
    document.body.classList.add("leaderboard")
  }
}
</script>

<style lang="scss" scoped>
  img {
    display: inline-block;
    margin: 0 auto 20px;
    max-width: 70%;
  }

  .leaderboard {
    margin-bottom: 50px;
  }
</style>
